import { useEffect, useState } from 'react';
import { skipToken, useResource, useResourceActions } from 'pulse/react';
import { SearchTicketsRpc } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/TicketsRpc.resources';
import { useVisiblePollInterval } from '../hooks/useVisiblePollInterval';
import { useRefetchOnWindowFocus } from '../utils/useRefetchOnWindowFocus';
import { getIsPreview } from '../utils/isPreview';
import { generateDateFilter } from '../constants/filters';
import { getPortalAccountId, getPortalInstanceId } from 'portals-platform-lib';
import { decodeSearchTicket } from './searchTickets';
export const DEFAULT_PAGE_LENGTH = 10;
export const LISTINGS_POLL_INTERVAL = 15000;
export const useTicketListingsSearch = ({
  pageLength = DEFAULT_PAGE_LENGTH,
  offset,
  pollInterval = LISTINGS_POLL_INTERVAL,
  sort,
  searchString,
  createDateFilter,
  lastActivityFilter,
  ticketView,
  statusFilter
}) => {
  const {
    isPreview
  } = getIsPreview();
  const [total, setTotal] = useState(0);
  const dateFilters = [generateDateFilter('createdate', createDateFilter), generateDateFilter('hs_lastactivitydate', lastActivityFilter)].filter(filter => filter != null);
  const params = {
    accountId: getPortalAccountId(),
    portalInstanceId: getPortalInstanceId(),
    params: {
      ticketView,
      statusFilter,
      searchString: searchString || undefined,
      sort,
      dateFilters,
      offset,
      pageLength
    }
  };
  const visiblePollInterval = useVisiblePollInterval(pollInterval);
  const {
    data,
    loading,
    error
  } = useResource(SearchTicketsRpc, {
    params: isPreview ? skipToken : params,
    pollInterval: visiblePollInterval
  });
  const {
    invalidate
  } = useResourceActions(SearchTicketsRpc, {
    params
  });
  useRefetchOnWindowFocus({
    refetch: invalidate,
    loading
  });
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setTotal(0);
  }, [createDateFilter, lastActivityFilter, searchString, statusFilter, ticketView]);
  useEffect(() => {
    if ((data === null || data === void 0 ? void 0 : data.total) !== undefined) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setTotal(data.total);
    }
  }, [data]);
  return {
    data: data === null || data === void 0 ? void 0 : data.results.map(decodeSearchTicket),
    total,
    responseTotal: data === null || data === void 0 ? void 0 : data.total,
    refetch: invalidate,
    loading: loading && !data,
    error
  };
};